<script setup>
import { computed } from 'vue';

const starImageHalf = new URL('@/assets/svg/icons/half-star.svg', import.meta.url).href;
const starImage = new URL('@/assets/svg/icons/star.svg', import.meta.url).href;

const stars = computed(() => {
  const starScore = (props.rating * 0.5).toString().split('.');
  let starResult = starScore[0] > 1 ? `<img src="${starImage}" alt="" />`.repeat(starScore[0]) : null;
  starResult += starScore[0] >= 1 ? `<img src="${starImageHalf}" alt="" />` : null;
  return starResult;
});

const props = defineProps({
  rating: {
    type: Number,
    required: true,
  },
  numberOfReviews: {
    type: Number,
    required: true,
  },
});

</script>

<template>
  <div class="container-fluid rating">
    <ul>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <li v-html="stars" />
      <!-- eslint-disable vue/no-v-html @intlify/vue-i18n/no-v-html -->
      <li
        v-html="
          $t('general.footer.rating', {
            rating: `<strong>${rating}</strong>`,
            numberOfReviews: `<strong>${numberOfReviews}</strong>`,
          })
        "
      />
      <!-- eslint-enable -->
    </ul>
  </div>
</template>

<style lang="scss">
.rating {
  background-color: var(--theme-font-color-accent-25);
  display: flex;
  justify-content: center;
  padding: 1.7rem 1.6rem 1.7rem 1.6rem;

  ul {
    list-style: none;
    padding: 0;
    display: flex;
    align-items: center;
    margin: 0;
  }
}
</style>
